import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import styles from './layout.module.scss'
import { MainHeader } from './Header/MainHeader'
import { MainSidebar } from './MainSidebar'
import { MainFooter } from './MainFooter'
import { useAuthStatus } from '../utils'
import { ModalProvider, useModal } from '../contexts/ModalContext'
import { ModalLoginFail } from '../components/modal/ModalLoginFail'
import { ModalAfterMove } from '../components/modal/ModalAfterMove'
import { ModalWithDrawMember } from '../components/modal/ModalWithDrawMember'
import { ModalServiceAlert } from '../components/modal/ModalServiceAlert'
import { ModalPP } from '../components/modal/ModalPP'
import { ModalCaddieProfile } from '../components/modal/ModalCaddieProfile'
import { useIsMobile } from '../hooks'

// ModalProvider 내부 컴포넌트
export const SpoeumLayout = () => {
	const [auth] = useAuthStatus()
	const location = useLocation()

	const isMobile = useIsMobile()

	// 사이드바를 숨겨야 하는 경로들
	const hideSidebarPaths = ['/onboarding', '/signup', '/certify', '/']
	const shouldHideSidebar = hideSidebarPaths.some((path) =>
		path === '/' ? location.pathname === '/' : location.pathname.startsWith(path),
	)

	return (
		<ModalProvider>
			<div className={styles.pageFrame}>
				<MainHeader />
				<div className={styles.exceptHeader}>
					{auth.isAuthentication === true && !shouldHideSidebar && !isMobile && (
						<MainSidebar />
					)}
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							flex: 1,
							height: '100%',
							width: '100%',
						}}>
						<div
							className={styles.content}
							style={{
								width: '100%',
								flex: 1,
								minHeight: '0',
								flexDirection: isMobile ? 'column' : 'row',
								display: 'flex',
							}}>
							<div
								className={styles.asideContent}
								style={{
									flex: 1,
									alignItems: 'center',
									minHeight: 0,
									overflowY: 'auto',
								}}>
								<Outlet />
								{isMobile && location.pathname !== '/search' && (
									<div style={{ flexShrink: 0, width: '100%' }}>
										<MainFooter />
									</div>
								)}
							</div>
						</div>
						{!isMobile && <MainFooter />}
					</div>
				</div>
			</div>
		</ModalProvider>
	)
}
